"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var button_component_1 = require("@cian/button-component");
var utils_1 = require("@cian/utils");
var icons_1 = require("./icons");
var styles = require("./index.css");
exports.MotivationPopup = function (_a) {
    var onCloseClick = _a.onCloseClick, onLoginClick = _a.onLoginClick, onRegisterClick = _a.onRegisterClick, isVisible = _a.isVisible;
    return (React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['container'], isVisible && styles['container--visible'])),
        React.createElement("div", { className: styles['tooltip'] },
            React.createElement("button", { className: styles['button-close'], onClick: onCloseClick }, icons_1.iconClose),
            React.createElement("strong", { className: styles['header'] },
                icons_1.iconGreenMark,
                "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043E \u0432 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435"),
            React.createElement("div", { className: styles['content'] },
                React.createElement("p", { className: styles['text'] }, "\u0412\u043E\u0439\u0434\u0438\u0442\u0435, \u0434\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0441 \u043B\u044E\u0431\u043E\u0433\u043E \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430"),
                React.createElement("div", { className: styles['buttons'] },
                    React.createElement(button_component_1.Button, { onClick: onLoginClick }, "\u0412\u043E\u0439\u0442\u0438"),
                    React.createElement("button", { className: styles['button-register'], onClick: onRegisterClick }, "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F"))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/shared/favorite_button/motivation_popup/index.tsx
// module id = 300
// module chunks = 2